
import { Component, Vue } from "vue-property-decorator";
import { accountApi } from "../../services/api/account/account";
import PanamaLayout from "../../layouts/PanamaLayout.vue";
import UserProfile from "../../components/UserProfile.vue";
import EmailVerified from "../../components/EmailVerified.vue";
import SecretQuestion from "../../components/SecretQuestion.vue";
import DigitalPin from "../../components/DigitalPin.vue";
import RecognitionPassport from "../../components/RecognitionPassport.vue";
import AdditionalProfile from "../../components/AdditionalProfile.vue";

@Component({
  components: {
    PanamaLayout,
    UserProfile,
    EmailVerified,
    SecretQuestion,
    DigitalPin,
    RecognitionPassport,
    AdditionalProfile,
  },
})
export default class Profile extends Vue {
  private profile: any = {};
  private roles: any = [];

  $router: any;

  async mounted() {
    await this.load();

    if (this.profile.roles?.length) {
      this.roles = this.profile.roles;
    }
  }

  private async load() {
    try {
      this.profile = await accountApi.profile();
    } catch {
      await this.$router.push({ name: "Login" });
    }
  }
}
